import type { CSSProperties, ReactNode } from 'react';
import { memo } from 'react';
import cx from 'clsx';

import { useSelectContext } from './context';

import styles from './Option.module.css';

type Props<T> = {
  value?: T;
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
};

const Option = <T extends unknown>({
  value,
  children,
  disabled = false,
  className,
  style,
}: Props<T>) => {
  const context = useSelectContext();

  return (
    <li
      role="presentation"
      className={cx(styles.option, disabled && styles.disabled, className)}
      onClick={() => {
        if (!disabled) {
          context.onChange?.(value as T);
        }
      }}
      style={style}
    >
      {children}
    </li>
  );
};

export default memo(Option);
